import { CIS_LEVELS, formatMultiplier } from '../utils/cisLevels'

export default function CisLevelTable({ currentLevelKey, className = '' }) {
  return (
    <div className={`grid grid-cols-2 sm:grid-cols-4 gap-2 ${className}`}>
      {CIS_LEVELS.map((l) => (
        <div
          key={l.key}
          className={`border-2 ${l.border} ${l.bg} p-3 flex flex-col gap-1 ${
            currentLevelKey === l.key ? 'ring-2 ring-primary-container ring-offset-1 ring-offset-surface' : ''
          }`}
        >
          <p className={`font-extrabold text-[12px] uppercase tracking-widest ${l.color}`}>{l.label}</p>
          <p className="text-[10px] text-on-surface-variant font-mono">
            {l.min.toLocaleString()} {l.max == null ? '+' : `– ${l.max.toLocaleString()}`} CIS
          </p>
          <p className="text-[11px] font-bold text-on-background">
            {formatMultiplier(l.multiplier)} CPT rewards
          </p>
        </div>
      ))}
    </div>
  )
}